import { render, staticRenderFns } from "./role.vue?vue&type=template&id=d356e664&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d356e664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d356e664')) {
      api.createRecord('d356e664', component.options)
    } else {
      api.reload('d356e664', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=d356e664&scoped=true&", function () {
      api.rerender('d356e664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work_order/config/role.vue"
export default component.exports